import { IDisposable } from "../../../../Global/Base/IDisposable";
import { ArrayUtils } from "../../../../Global/Base/Utils/ArrayUtils";
/**
 * Uvolnitelná instance
 */
export interface IDisposableInstance extends IDisposable {
    /**
     * Identifikátor instance
     */
    instanceID: string;
    /**
     * Určuje, zda je instance uložená a tedy zda ji lze uvolnit
     */
    isNew: boolean;
}

/**
 * Kolekce instancí, která zajišťuje jejich uvolnění při jejich odstranění
 * @includeToDoc
 */
export class InstanceCollection implements IDisposable {
    private __instances: IDisposableInstance[] = [];

    private get _instances(): IDisposableInstance[] {
        return this.__instances;
    }

    private set _instances(instances: IDisposableInstance[]) {
        this.__instances = instances ?? [];
    }

    /**
     * Všechny aktuálně držené instance
     */
    public get instances(): ReadonlyArray<IDisposableInstance> {
        return this.__instances;
    }

    /**
     * Zkontroluje stávající instance, nově předané přidá nebo zachová a staré uvolní. Při hodnotě undefined nebo přázdném poli odstraní všechny uložené.
     * @param instances Instance, které mají být zachovány a nebo přidány
     */
    public async keep(instances?: IDisposableInstance[]): Promise<void> {
        if (instances) //odstraní připadné undefined instance a udělá distinct pole.
            instances = instances.filter((value, index, array) => value && array.indexOf(value) == index);

        const forDispose: IDisposableInstance[] = [];
        let index: number;

        for (const i of this._instances) {
            if (i.isNew)
                continue;

            if (instances && (index = instances.indexOf(i)) > -1) {
                instances.splice(index, 1); // pokud už tato instance byla v kolekci, tak se odstraní z nových, aby se znova nepřidala
                continue;
            }

            forDispose.push(i);
        }

        // odstraní staré instance
        this._instances = ArrayUtils.removeAll(this._instances, forDispose);
        //  a přidá nové
        if (instances)
            this._instances = this._instances.concat(instances);

        await Promise.all(forDispose.map(i => i.dispose()));
    }

    /**
     * Uvolní všechny držené instance
     */
    public dispose(): void {
        Promise.all(this._instances.map(i => i.dispose()));
        this._instances = [];
    }
}
